require("regenerator-runtime/runtime");

// Import Base Styles
import "~buildable/utils/styles";

// Import Utility Styles
import "~buildable/utils/block-bg-options/styles.scss";
import "~buildable/utils/block-color-options/styles.scss";

// Import Higher-Order Component Styles
import "~buildable/higher-order/with-inspector-tabs/styles.scss";
import "~buildable/higher-order/with-styles-previews/styles.scss";

// Import Component Styles
import "~buildable/components/appendable-panel/styles.scss";
import "~buildable/components/button-field/styles.scss";
import "~buildable/components/clickable-icon/styles.scss";
import "~buildable/components/icon-classes/styles.scss";
import "~buildable/components/image-video-embed/styles.scss";
import "~buildable/components/inspector-appender/styles.scss";
import "~buildable/components/multi-button-fields/styles.scss";
import "~buildable/components/searchable-multi-select/styles.scss";
import "~buildable/components/small-appender/styles.scss";
import "~buildable/components/theme-color-select/styles.scss";
import "~buildable/components/url-popover/styles.scss";
import "~buildable/components/wp-media-preview/styles.scss";

// WP Imports
import { registerBlockCollection, getCategories, setCategories } from "@wordpress/blocks";
import { __ } from '@wordpress/i18n'

// import "./heading-toolbar-buttons";
import "./core-block-parent-filter";
import "./theme-text-color-format/index";

// Register our block collection or category (WP <= 5.3).
if ( typeof registerBlockCollection !== "undefined" ) {
  registerBlockCollection( 'buildable', {
    title: __( 'Buildable' ),
    // icon: "smiley",
  } )
} else {
  setCategories( [
    ...getCategories(),
    {
      slug: 'buildable',
      title: __( 'Buildable' ),
      // icon: "smiley",
    },
  ] )
}
